import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

import ManageSecurityDeposit from '../../../components/siteadmin/ManageSecurityDeposit/ManageSecurityDeposit';

import s from './manageSecurityDeposit.css';

const ManageSecurityDepositContainer = () => {

  return <ManageSecurityDeposit />
}

export default compose(
  withStyles(s),
)(ManageSecurityDepositContainer);
